import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { NoAuthGuard } from './guards/no-auth.guard';
import { BrowserUtils } from '@azure/msal-browser';

const routes: Routes = [
  { path: '', canActivate: [NoAuthGuard], component: LoginComponent, data: { showHeader: false } },
  {
    path: 'login', canActivate: [NoAuthGuard], component: LoginComponent, data: { showHeader: false }
  },
  { path: 'invoices', canActivate: [AuthGuard], loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule), data: { showHeader: true } },
  {
    path: 'customers', canActivate: [AuthGuard, NgxPermissionsGuard], loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule), data: {
      showHeader: true,
      permissions: {
        only: ['analyst', 'user', 'visu', 'visupartial', 'commercial', 'bpo'],
        redirectTo: '/invoices'
      }
    }
  },
  { path: '**', redirectTo: 'invoices' }
];

const isIframe = BrowserUtils.isInIframe() && !window.opener && window.location.href.indexOf("logout") < 0;

@NgModule({
  imports: [RouterModule.forRoot(routes
    //, { initialNavigation: !isIframe ? 'enabled' : 'disabled' }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
